import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ProjectAnalytics from './components/ProjectAnalytics';
import CourseAnalytics from './components/CourseAnalytics';
import RevenueAreaChart from './components/RevenueChart';
import GlobalSelectFieldWithoutFormikNew from '../../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { useSelector } from 'react-redux';
import { getCourseUnderProject } from '../../../../../redux/features/courseSlice';
import { useDispatch } from 'react-redux';
import { getCourseTrend, getProjectTrend } from '../../../../../redux/features/poinTrackerSlice';

export default function ProjectTrendAnalysisMain({ fromDate, toDate }) {
  const [tab, setTab] = useState(0);

  const allProjects = useSelector((state) => state.general.allprojects);
  const courses = useSelector((state) => state.course.courseUnderProject || []);

  const [project, setProject] = useState({ id: -1, value: '' });
  const [course, setCourse] = useState({ id: -1, value: '' });

  const dispatch = useDispatch();

  useEffect(() => {
    if (project?.id) {
      dispatch(getCourseUnderProject(project.id === -1 ? null : project?.id));
    }
  }, [project?.id, dispatch]);

  useEffect(() => {
    const params = {
      projectId: project?.id === -1 ? null : project?.id,
      courseId: course?.id === -1 ? null : course?.id,
    };
    const trendSignal = tab ? dispatch(getCourseTrend(params)) : dispatch(getProjectTrend(params));
    return () => {
      trendSignal.abort();
    };
  }, [project, dispatch, course, tab]);

  return (
    <Stack gap={2}>
      <Typography variant="h5">Project Trend Analytics</Typography>
      <Tabs onChange={(_, v) => setTab(v)} value={tab}>
        <Tab sx={{ px: 0 }} value={0} label="Project Analytics" />
        <Tab value={1} label="Course Analytics" />
      </Tabs>

      <GlobalSelectFieldWithoutFormikNew
        label={tab === 0 ? 'Project' : 'Course'}
        data={[
          { [tab === 0 ? 'id' : 'course_available_id']: -1, [tab === 0 ? 'name' : 'course_name']: 'All' },
          ...((tab === 0 ? allProjects?.projects : courses) ?? []),
        ]}
        sx={{ maxWidth: 300 }}
        keys={{
          itemId: tab === 0 ? 'id' : 'course_available_id',
          itemValue: tab === 0 ? 'name' : 'course_name',
        }}
        setChange={tab === 0 ? setProject : setCourse}
        selectedDetails={tab === 0 ? project : course}
      />
      <Box minHeight={600} width={'100%'}>
        {tab === 0 ? <ProjectAnalytics bgcolor={'#1447E6'} /> : <CourseAnalytics bgcolor={'#8200DB'} />}
      </Box>

      <Stack>
        <RevenueAreaChart tab={tab ? 'courseTrend' : 'projectTrend'} />
      </Stack>
    </Stack>
  );
}
